import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    removeMenuShowClass() {
        document.body.classList.remove('show-ls2025-menu');
    }
}
